import type { StyleProperties } from '@webbuilder/style-engine'

/**
 * Lo que distingue a la tarjeta con borde de la de base: sin relleno y con un
 * borde fino del color de borde de la paleta.
 *
 * El look copiaba lo mismo en las dos —relleno, borde, sombra— y quedaban
 * idénticas: aplicar la segunda no cambiaba nada. Ahora comparten la forma del
 * look (radio, espaciado) y cada una conserva su manera de separarse del fondo.
 * Transparente, se distingue sobre cualquier sección; el grosor del look se
 * respeta si ya traía borde (el brutalista lleva 2px).
 */
export function outlinedCardStyles(styles: StyleProperties): StyleProperties {
  const width = parseFloat(String(styles.borderWidth ?? '0')) >= 1 ? String(styles.borderWidth) : '1px'
  return {
    ...styles,
    background: 'transparent',
    backgroundColor: 'transparent',
    borderStyle: 'solid',
    borderWidth: width,
    borderColor: 'var(--wb-border)',
    boxShadow: 'none',
  }
}
